import { NgComponentOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MENU_ITEMS } from '@core/configs/main-menu.config';

@Component({
  selector: 'app-main-menu',
  imports: [NgComponentOutlet, RouterLink],
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss',
})
export class MainMenuComponent {

  public menuItems = MENU_ITEMS;
}
